import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tours-page06',
  templateUrl: './tours-page06.component.html',
  styleUrls: ['./tours-page06.component.css']
})
export class ToursPage06Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
